// Libraries
declare const module: any;
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';
import { AppContainer } from 'react-hot-loader';

// Components
import App from './src/App';

// Store
import stores from './src/stores/AllStores';

// Initialize React
const render = component => {
    ReactDOM.render(
        <Provider store={stores}>
            <AppContainer>
                <App />
            </AppContainer>
        </Provider>,
        document.getElementById('root')
    );
};

render(App);

if (typeof module !== 'undefined' && typeof module.hot !== 'undefined' && module.hot) {
    module.hot.accept('./src/App', () => {
        render(App);
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/index.tsx